// extracted by mini-css-extract-plugin
export var category = "index-module--category--294ac";
export var date = "index-module--date--6ec70";
export var date_category = "index-module--date_category--aeab2";
export var featured_blogs_container = "index-module--featured_blogs_container--5d1f8";
export var text_container = "index-module--text_container--7a144";